import React from 'react';
import styled from '@emotion/styled';

import ExternalLinksCollection, { ExternalLinksShape } from '../ExternalLinksCollection';

import { minTablet } from '../styles/breakpoints';

const Container = styled.section`
  padding-bottom: 3em;
  margin-bottom: 30px;
  ${minTablet} {
    margin-bottom: 50px;
  }
`;

const RelatedMaterials = ({ sources }) => (
  <Container>
    <ExternalLinksCollection sources={sources} collapsable />
  </Container>
);

RelatedMaterials.propTypes = {
  sources: ExternalLinksShape.isRequired,
};

export default RelatedMaterials;



// WEBPACK FOOTER //
// ./src/components/RelatedMaterials/RelatedMaterials.js